var map = {
	"./NewMain.vue": 54652,
	"./NewSidebar.vue": 95513,
	"./NewSidebarItem.vue": 42001,
	"./NewToolbar.vue": 14559,
	"./SidebarFilter.vue": 58079,
	"./SidebarItem.vue": 41335,
	"./SvgIcon.vue": 37597
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 44085;